var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFilter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 17,
    viewBox: "0 0 23 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.2789 4.40741H0.985714C0.441319 4.40741 0 3.98457 0 3.46296C0 2.94136 0.441319 2.51852 0.985714 2.51852H13.2789C13.708 1.06502 15.1027 0 16.7571 0C18.4115 0 19.8063 1.06502 20.2354 2.51852H22.0143C22.5587 2.51852 23 2.94136 23 3.46296C23 3.98457 22.5587 4.40741 22.0143 4.40741H20.2354C19.8063 5.86091 18.4115 6.92593 16.7571 6.92593C15.1027 6.92593 13.708 5.86091 13.2789 4.40741ZM15.1143 3.46296C15.1143 2.59363 15.8498 1.88889 16.7571 1.88889C17.6645 1.88889 18.4 2.59363 18.4 3.46296C18.4 4.3323 17.6645 5.03704 16.7571 5.03704C15.8498 5.03704 15.1143 4.3323 15.1143 3.46296Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.72109 14.4815H22.0143C22.5587 14.4815 23 14.0586 23 13.537C23 13.0154 22.5587 12.5926 22.0143 12.5926H9.72109C9.29203 11.1391 7.89725 10.0741 6.24286 10.0741C4.58846 10.0741 3.19369 11.1391 2.76462 12.5926H0.985714C0.44132 12.5926 0 13.0154 0 13.537C0 14.0586 0.44132 14.4815 0.985714 14.4815H2.76462C3.19369 15.935 4.58846 17 6.24286 17C7.89725 17 9.29203 15.935 9.72109 14.4815ZM4.6 13.537C4.6 12.6677 5.33553 11.963 6.24286 11.963C7.15018 11.963 7.88571 12.6677 7.88571 13.537C7.88571 14.4064 7.15018 15.1111 6.24286 15.1111C5.33553 15.1111 4.6 14.4064 4.6 13.537Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.0cafe21f07855da0ea5e5c06f8e02f45.svg";
export { ForwardRef as ReactComponent };